
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"25","height":"25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.902 4.751a1.421 1.421 0 012.462 0l7.93 13.737a1.421 1.421 0 01-1.23 2.132H4.202a1.421 1.421 0 01-1.23-2.132l7.93-13.737z","fill":"#748190"}}),_c('path',{attrs:{"d":"M12.877 9.158v-.054h-1.484l.001.054.109 6.102v.053h1.264l.001-.053.109-6.102zm-.744 8.697c.485 0 .89-.395.89-.89a.894.894 0 00-.89-.885c-.489 0-.89.4-.89.886 0 .493.401.89.89.89z","fill":"#fff","stroke":"#fff","stroke-width":".107"}})])
          )
        }
      }
    